export interface BooleanFlag {
  key: string;
  type: "boolean";
  /** Served while the Flipt snapshot has not loaded yet, or when Flipt is unreachable. */
  defaultValue: boolean;
}

export interface VariantFlag {
  key: string;
  type: "variant";
  /** Served while the Flipt snapshot has not loaded yet, or when Flipt is unreachable. */
  defaultVariant: string;
}

export const FeatureFlags = {
  REFER_A_FRIEND: { key: "refer-a-friend", type: "boolean", defaultValue: false },
  PUBLIC_PROFILE: { key: "public-profile", type: "boolean", defaultValue: false },
  POKER_WEB_COMPONENT: { key: "poker-web-component", type: "boolean", defaultValue: false },
  RAKEBACK: { key: "rakeback", type: "boolean", defaultValue: false },
  /**
   * Casino lobby only. The public profile's tiles are built server-side from the operator's
   * central-images `default-style`, which no flag is read for, so backing the feature out there
   * means removing that config key rather than turning this off.
   */
  CASINO_ENFORCED_THUMBNAIL_STYLE: { key: "casino-enforced-thumbnail-style", type: "boolean", defaultValue: false },
  /**
   * Live rewards SSE stream. Off by default because an edge that holds long-lived responses back
   * (seen behind Cloudflare) turns it into a reconnect every few seconds; the rewards page's poll
   * keeps the list fresh without it. Target players with a segment on the userId context.
   */
  REWARDS_LIVE_STREAM: { key: "rewards-live-stream", type: "boolean", defaultValue: false },
} as const satisfies Record<string, BooleanFlag | VariantFlag>;
